var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cms-block',_vm._b({on:{"block-selected":_vm.selectBlock}},'cms-block',_vm.$props,false),[_c('cms-component-text',_vm._b({attrs:{"comp-id":"text","component":_vm.block.text,"placeholder":"Text|Texte"}},'cms-component-text',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }